module.exports = "<div class=\"categories-container\" *ngIf=\"categories\">\r\n  <mat-checkbox\r\n    *ngFor=\"let category of categories\"\r\n    [checked]=\"checkedMap[category._id]\"\r\n    (click)=\"toggleValue(category._id)\"\r\n  >\r\n    {{ category.name }}\r\n\r\n  </mat-checkbox>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-suggested-in-categories-form/product-suggested-in-categories-form.component.html
// module id = ./libs/atenea-cms-brand/src/products/product-suggested-in-categories-form/product-suggested-in-categories-form.component.html
// module chunks = main